import { handleThisMessageClick, handleThisMessageOver } from '../menuActions'

// Shared back-to-main button — shown on any tab or in edit mode. Sits before the
// edit/new action button; clicking returns to the main message view.
export function BackButton({ label }: { label: string }) {
  return (
    <li
      className="md-sidebar__this-message md-sidebar__back-main flex h-[34px] flex-[0_0_auto] cursor-pointer items-center overflow-visible rounded-[10px] bg-[#2563eb1a] py-0 pl-1.5 pr-1 text-[13px] font-medium leading-none text-[#5b6675] transition-colors duration-150 hover:bg-[#2563eb2e]"
      onClick={handleThisMessageClick}
      onMouseOver={(e) => handleThisMessageOver(e, true)}
      onMouseOut={(e) => handleThisMessageOver(e, false)}
    >
      <div
        className="md-sidebar__menu-item-label md-sidebar__back-label flex h-[34px] max-w-[130px] cursor-pointer items-center overflow-hidden px-2 font-semibold text-[#2563eb] text-ellipsis"
      >
        <span aria-hidden="true" className="mr-[5px] text-[15px] font-bold">‹</span>
        {label}
      </div>
    </li>
  )
}
